var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-error border-EXPONDO-red w-full p-6 bg-EXPONDO-red-light text-EXPONDO-red"},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.errorMessage))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }